import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

export const getComponentDesignNames = createSelector(
  (state: RootState) => state.componentDesigns.data,
  (componentDesigns) =>
    Object.fromEntries(
      Object.values(componentDesigns).map((componentDesign) => [componentDesign.guid, componentDesign.component.name]),
    ),
);
